import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { searchCalenderListUrl, GET_BLOCKED_CALENDER_LIST, unblockCalenderUrl, UNBLOCK_CALENDER, getBlockedCalenderListUrl, SEARCH_CALENDER_LIST, BLOCK_CALENDER, blockCalenderUrl, headers } from "../../utils/constants"
import moment from 'moment';

export const search_calender_action = (CityID, CenterID, Bookingdate, TimeslotID, Montlyview) => async (dispatch) => {
    try {
        const mapdata = {
            CityID: CityID,
            CenterID: CenterID,
            Bookingdate: Bookingdate != null && Bookingdate != '' ? moment(Bookingdate).format('YYYY-MM-DD') : null,
            TimeslotID: TimeslotID,
            Montlyview: Montlyview,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(searchCalenderListUrl, mapdata, headers);

        dispatch({
            type: SEARCH_CALENDER_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const block_calender_action = (BlockCalenderList, userID) => async (dispatch) => {
    try {
        const mapData = {
            UserID: userID == '' || userID == null ? 0 : userID,
            BlockCalenderList: BlockCalenderList
        }
        console.log("------>", mapData)
        const res = await axiosPost(blockCalenderUrl, mapData, headers)

        dispatch({
            type: BLOCK_CALENDER,
            payload: res
        })
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const get_block_calendar_list_action = (CenterID, date, clientName) => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            CenterID: CenterID != '' && CenterID != null ? CenterID : null,
            Date: date != null && date != '' ? moment(date).format('YYYY-MM-DD') : null,
            // FromDate: FromDate != null && FromDate != '' ? moment(FromDate).format('YYYY-MM-DD') : null,
            // ToDate: ToDate != null && ToDate != '' ? moment(ToDate).format('YYYY-MM-DD') : null,
            // orderNo: orderNo,
            clientName: clientName,
        }
        console.log("input data for search===>", mapdata)
        const res = await axiosGet(getBlockedCalenderListUrl, mapdata, headers);

        dispatch({
            type: GET_BLOCKED_CALENDER_LIST,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const unblock_calender_action = (unblockCalenderList) => async (dispatch) => {
    try {
        const mapData = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            unblockCalenderList: unblockCalenderList
        }
        console.log("------>", mapData)
        const res = await axiosPost(unblockCalenderUrl, mapData, headers)

        dispatch({
            type: UNBLOCK_CALENDER,
            payload: res
        })
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}